<template>
    <div>
        <div class="fullscreen-page-title">
            {{ tokens.fullScreen.verification.toUpperCase()}} {{(newVerificationTitle)}}
        </div>
        <div class="row form-row">
            <div class="col"
                 v-for="(docData, i) in documentsData"
                 :key="'docData'+i"
            >
                <div class="document"
                     :class="{
                        over: docData.over && [0, 1].indexOf(docData.status) === -1
                     }"
                     :title="docData.title"
                     v-cloak
                     @drop.prevent="e => addFile(i, e)"
                     @dragover.prevent
                     @dragenter="over(i, true)"
                     @dragleave="over(i, false)"
                     @dragover="over(i, true)"
                >
                    <div class="document-inner">
                        <!--                        <i class="material-icons" :class="docData.cssClass">{{ docData.icon }}</i>-->
                        <div class="img-inner">
                            <!--                            <img v-show="docData.cssClass !== 'wait-fs' && docData.cssClass !== ''" class="state" :src="docData.cssClass === 'green-fs' ? 'image/accept.svg' : 'image/error.svg'" alt="">-->
                            <img class="icon" :class="docData.cssClass" :src="`../image/misc/${docData.icon}.svg`" alt="">
                        </div>
                        <div v-if="[-1, 2].indexOf(docData.status) === -1" 
                            class="docname" 
                            :class="docData.cssClass">{{ docData.text }}</div>
                        <label v-else   
                            for="fileInput"  
                            v-tooltip="docData.text" 
                            class="docname" 
                            :class="docData.cssClass">{{ docData.text }}</label>
                    </div>
                    <div class="tip" :class="{hide: [0, 1].indexOf(docData.status) !== -1}">
                        {{ tokens.fullScreenVerification.dragAndDrop }}
                    </div>
                    <input type="file" title="" @change="documentSelected($event, i)"
                    id="fileInput"      :class="{hide: [-1, 2].indexOf(docData.status) === -1}"/>
                </div>
            </div>
        </div>

        <div class="progress-bar">
            <div class="empty">
                <div class="filled" :style="{width: this.searchSuccessfully / documentsData.length * 100 + '%'}"></div>
            </div>
            <p>{{ progressBarState }}</p>
        </div>

        <div class="form-row fs" v-if="customKycDocument">
            <a href="https://app.signnow.com/rctapp/login" class="dod" target="_blank">DOD</a>
        </div>

        <div v-if="questions.length>0" class="questions">
            <div class="row">
                <div class="form-row fs">
                    <div class="form-title">{{ tokens.fullScreenVerification.questionnaire.toUpperCase() }}</div>
                </div>
            </div>

            <div class="row">
                <div class="questions-item">
                    <div v-for="question in questions" :key="question.id">
                        <div class="form-row fs">
                            <label class="fs">{{ question.question }}</label>
                            <input type="text" class="form-control fs" v-model="question.answer">
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-row fs">
                <button class="fs-normal" v-on:click="sendAnswers">{{
                        tokens.fullScreenVerification.sendAnswers
                    }}
                </button>
            </div>
        </div>

        <div class="form-row fs">
            <div class="form-title">{{ tokens.fullScreenVerification.documentsList }}</div>
        </div>


        <div class="table-cont">
            <table class="cabinet fs">
                <thead>
                <tr>
                    <th class="fs">{{ tokens.fullScreenVerification.document.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenVerification.timeUploaded.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenVerification.timeProcessed.toUpperCase() }}</th>
                    <th class="fs">{{ tokens.fullScreenVerification.status.toUpperCase() }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="document in documents"
                    :key="document.id"
                    class="fs"
                >
                    <td class="fs">{{ tokens.fullScreenVerification.types[document.type] }}</td>
                    <td class="fs">{{ new Date(document.time_created * 1000).toLocaleString() }}</td>
                    <td class="fs">
                        {{ document.time_processed ? new Date(document.time_processed * 1000).toLocaleString() : '-' }}
                    </td>
                    <td class="fs">{{ tokens.statuses[document.status] }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {NOTIFICATION} from "@/store/mutations.type"
import {DOCUMENT_UPLOAD} from "@/store/actions.type"
import {
    BRAND,
    CUSTOM_KYS_DOCUMENT,
    CUSTOM_SELFIE,
    CUSTOM_SELFIE_TEXT,
    KYC_DOCUMENTS,
    NEW_VERIFICATION_TITLE, STATIC_BASE
} from "@/common/config"
import RestService from "@/common/rest.service"

export default {
    name: "Verification",
    data() {
        return {
            kycDocuments: KYC_DOCUMENTS,
            newVerificationTitle: NEW_VERIFICATION_TITLE || '',
            customSelfie: CUSTOM_SELFIE,
            customSelfieText: CUSTOM_SELFIE_TEXT,
            customKycDocument: CUSTOM_KYS_DOCUMENT,
            staticBase: STATIC_BASE,
            brand: BRAND,
        }
    },
    methods: {
        addFile(type, e) {
            this.documentsData[type].over = false

            if (!e.dataTransfer.files || [0, 1].indexOf(this.documentsData[type].status) !== -1) {
                return
            }

            let data = new FormData()

            data.append('file', e.dataTransfer.files[0])
            data.append('data', JSON.stringify({
                type
            }))

            this.$store.dispatch(DOCUMENT_UPLOAD, data)
        },
        over(type, val) {
            this.documentsData[type].over = val
        },
        documentSelected(e, type) {
            let data = new FormData()

            data.append('file', e.target.files[0])
            data.append('data', JSON.stringify({
                type
            }))

            this.$store.dispatch(DOCUMENT_UPLOAD, data)

            e.target.value = ''
        },
        sendAnswers() {
            let answersArray = []
            for (let n in this.questions) {
                answersArray.push({question_id: this.questions[n].id, answer: this.questions[n].answer})
            }

            RestService.post('/kyc/questions', {answers: answersArray})
                .then(() => {
                    this.$store.commit(NOTIFICATION, 'Answers have been saved')
                })
        },
    },
    computed: {
        ...mapGetters(['documents', 'tokens', 'questions']),
        documentsData: function () {
            let resultingArray = [],
                docs = this.documents,
                icons = ['prof', 'home', 'cardFront', 'cardBack', 'file', 'selfile', 'other'],
                over = false,
                icon = '', status = '', cssClass = '', text = ''

            switch (this.brand) {
                case "corlexcorp":
                    icons = ['prof', 'home', 'cardFront', 'file', 'selfile', 'other']
                    break
            }

            this.kycDocuments.forEach((value, i) => {
                let typeToken;
                
                //crutch for nexbergag
                if(['nexbergag','crownexcapitalgroup','vertexcapitalgroup'].includes(this.brand)){
                    typeToken = this.tokens.fullScreenVerification.types2[value]
                }else{
                    typeToken = this.tokens.fullScreenVerification.types[value]
                }
                
                if (this.customSelfie && typeToken === 'Selfie') {
                    typeToken = this.customSelfieText
                }

                //crutch for byronplusglobal
                if(['stage_sharksoft','byronplusglobal'].includes(this.brand) && typeToken === 'Other'){
                    typeToken = 'Bank Statement'
                }

                let docsOfType = docs.filter(doc => doc.type === i)
                docsOfType.sort((a, b) => a.id - b.id)
                let lastDocOfType = docsOfType[docsOfType.length - 1]

                status = lastDocOfType ? lastDocOfType.status : -1
                icon = icons[i]
                switch (status) {
                    case -1:
                        cssClass = ''
                        text = this.tokens.fullScreenVerification.upload.toUpperCase() + ' ' + typeToken.toUpperCase()
                        break
                    case 0:
                        cssClass = 'wait-fs'
                        text = typeToken.toUpperCase() + ' - ' + this.tokens.fullScreenVerification.isUnderReview.toUpperCase()
                        break
                    case 1:
                        cssClass = 'green-fs'
                        text = typeToken.toUpperCase() + ' - ' + this.tokens.fullScreenVerification.isConfirmed.toUpperCase()
                        break
                    case 2:
                        cssClass = 'red-fs'
                        text = typeToken.toUpperCase() + ' - ' + this.tokens.fullScreenVerification.uploadAnotherDocument.toUpperCase()
                        break
                }
                let resultingDoc = {icon, over, status, cssClass, text}

                resultingArray.push(resultingDoc)
            })

            return resultingArray
        },

        searchSuccessfully() {
            let seachedDocuments = [],
                docs = this.documents,
                over = false,
                icon = '', status = ''


            this.kycDocuments.forEach((value, i) => {

                let docsOfType = docs.filter(doc => doc.type === i)
                docsOfType.sort((a, b) => a.id - b.id)
                let lastDocOfType = docsOfType[docsOfType.length - 1]

                status = lastDocOfType ? lastDocOfType.status : -1

                let resultingDoc = {icon, over, status}

                seachedDocuments.push(resultingDoc)

            })

            let successfully = 0

            seachedDocuments.forEach(el => {
                if (el.status === 1) {
                    successfully++
                }
            })

            return successfully
        },

        progressBarState() {
            return `${this.searchSuccessfully} ${this.tokens.fullScreenVerification.progressBarOf} ${this.documentsData.length} ${this.tokens.fullScreenVerification.progressBarText}`
        }
    }
}
</script>

<style scoped>
.row {
    flex-direction: row !important;
    align-items: stretch;
    justify-content: space-between;
    margin-bottom: 0;
}

.col {
    flex: 0 0 32%;
    margin-bottom: 30px;
}

.questions {
    margin: 30px 0;
}

.progress-bar .empty {
    height: 15px;
    border: 1px solid var(--fs-border);
    border-radius: 10px;
    overflow: hidden;
}

.progress-bar .filled {
    height: 100%;
    background: linear-gradient(95deg, #60BD35 25%, rgba(135, 194, 60, 0.35) 90%);
    border-radius: 10px;
}

.progress-bar p {
    font-size: 1em;
    font-weight: 400;
    margin-top: 10px;
}

.document {
    width: 100%;
    height: 200px;
    border-radius: 10px;
    background: var(--background-dark-mid);
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    place-content: center space-evenly;
    position: relative;
    overflow: hidden;
    gap: 10px;
}

.img-inner {
    position: relative;
}

.document-inner {
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 10px;
    place-items: center center;
    margin: 0 auto;
}

.document.over, .document.over i {
    color: var(--white-to-black)
}

.document i {
    font-size: 6em;
    color: var(--font)
}

.document .docname {
    font-weight: 400;
    font-size: 1.2em;
    text-align: center;
    color: #989996;
}

.document label.docname {
    cursor: pointer;
    display: -webkit-box; 
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; 
    overflow: hidden; 
    text-overflow: ellipsis;  
    z-index: 5;
}

.document .docname.green-fs {
    color: var(--white-to-black);
}

.document .docname.red-fs {
    color: #AB0E0E;
}

.document .docname.wait-fs {
    color: #E67E0A;
}

.document input {
    position: absolute;
    width: 150%;
    height: 150%;
    top: -50%;
    left: -50%;
    cursor: pointer;
}

.tip {
    color: var(--white-to-black);
    text-align: center;
    margin: 0 auto;
    opacity: .6;
}

input, select, textarea {
    width: 100%;
    font-size: 1.2em;
}

textarea {
    font-family: inherit;
}

.questions-item {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.questions-item > div {
    flex: 0 0 45%;
}

.dod {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    height: 40px;
    padding: 10px;
    border-radius: 10px;
    background: var(--green);
    text-decoration: none;
    color: var(--white);
    cursor: pointer;
}

.img-inner .state {
    position: absolute;
    top: 30px;
    left: 40px;
    width: 30px;
    height: 30px;
    z-index: 1;
}

.document-inner .icon.green-fs {
    filter: invert(2) sepia(5) saturate(5) hue-rotate(35deg);
}

.document-inner .icon.red-fs {
    filter: none;
}

.document-inner .icon.wait-fs {
    filter: invert(0) sepia(5) saturate(15) hue-rotate(12deg);
}

.document-inner .icon {
    filter: invert(0) sepia(10) saturate(0) hue-rotate(15deg);
}

@media (min-width: 1000px) {
    .img-inner .state {
        position: absolute;
        top: 1.5vw;
        left: 2vw;
        width: 1.5vw;
        height: 1.5vw;
        z-index: 1;
    }

    .document {
        height: 7.5vw;
        padding-top: 1vw;
        gap: .5vw;
    }

    .document-inner img {
        width: 3vw;
        height: 3vw;
        object-fit: contain;
    }

    .document-inner {
        gap: .5vw;
    }

    .tip {
        font-size: .8vw;
    }

    .document-inner .docname {
        font-size: .8vw;
        max-width: 8.5vw;
    }

    .col {
        margin-bottom: 2vw;
    }

    .questions {
        margin: 1.5vw 0;
    }

    .progress-bar .empty {
        height: .8vw;
        border-radius: 1vw;
    }

    .progress-bar .filled {
        border-radius: 1vw;
    }

    .progress-bar p {
        margin-top: .6vw;
        font-size: 1vw;
        margin-bottom: 0.5vw;
    }
}

@media (max-width: 1000px) {
    .progress-bar {
        margin-top: 30px;
    }

    .img-inner .state {
        top: 35px;
        left: 50px;
    }

    .col {
        flex: 0 0 100%;
    }

    .form-row .col:last-child {
        margin-bottom: 0;
    }

    .questions-item > div {
        flex: 0 0 100%;
    }

    .document {
        grid-template-rows: repeat(2, auto);
        gap: 30px;
        height: 130px;
    }

    .docname {
        max-width: 150px;
    }
}
</style>
